import React, { useEffect, useState } from 'react';
import { 
    checkActionCode, 
    applyActionCode, 
    sendPasswordResetEmail,
} from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import Alert from 'react-bootstrap/Alert';
import {getSignInErrorMessage} from 'components/auth/signInErrors';

type UpdateEmailTypesenseParams = {
    email : string
}

type ChangePermissionsResult = {
    success: boolean
    reason?: string
}

export const RecoverEmailHandler = ({ auth, actionCode }) => {

    const [isLoading, setIsLoading] = useState(true);
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const customVerifyEmail = async () => {
        const info = await checkActionCode(auth, actionCode)
        const newEmail = info['data']['email']
        const functions = getFunctions();
        const updateEmailTypesense = httpsCallable<UpdateEmailTypesenseParams,ChangePermissionsResult>(functions, "updateEmailTypesense");

        try {
            // Apply the recovery first so Firebase Auth reflects the restored
            // email, then sync the roster from the authoritative Auth value.
            await applyActionCode(auth, actionCode)
            // The recovery has already applied, so a failed roster sync must
            // not stop the reset email: that email is what protects an
            // account whose address was changed by someone else.
            try {
                const res = await updateEmailTypesense({email: newEmail})
                if (!res.data.success){
                    console.warn('[RecoverEmailHandler] roster sync failed', res.data.reason)
                }
            } catch (syncError) {
                console.warn('[RecoverEmailHandler] roster sync failed', syncError)
            }
            await sendPasswordResetEmail(auth, newEmail)
            setSuccessMessage(`Your email ${newEmail} has been restored as the primary email for your account. We'll send you an email with a link to reset your password in case you think your account was compromised.`)
        } catch (error) {
            setErrorMessage(getSignInErrorMessage(error))
        } finally {
            setIsLoading(false)
        }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps -- TODO: [#915](https://github.com/CodeinPlace/cip-webapp/issues/915) - fix legacy lint issue
    useEffect( () => { customVerifyEmail() }, [])

    if (isLoading) {
        return <Alert variant={'primary'}>Loading...</Alert>;
    }

   if (errorMessage) {
       return <Alert variant={'danger'}>Error: {errorMessage}</Alert>
    } 

    return <Alert variant={'success'}>Success! {successMessage}</Alert>;
}